import React, { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { useParams, NavLink } from "react-router-dom";
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postSector, postSubSector, getSectorDetails, patchSectorUpdate, deleteSector, postSubSectorAdd } from '../../apiservices/ApiServices';

const SubSectors = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [data, setData] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const { id } = useParams();

    const postSectorsList = async (postData) => {
        try {
            const res = await postSector(postData);
            setMasterData(res.data.data.records);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postSubSectors = async (postData) => {
        setLoading(true);
        try {
            const res = await postSubSector(id, postData);
            setData(res.data.data);
            setLoading(false);
            console.log(res.data.data)

        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateSubSectors = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postSubSector(id, postData);
            setData(res.data.data);

        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postSectorsList(postData);
        postSubSectors(postData);
    }, [id]);

    const columns = useMemo(
        () => [
            {
                Header: "Sub Sectors Name",
                accessor: "sector_name",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const emptyStatement = {
        esectoreId: '',
        sectoreName: '',
        edescription: '',
        subSector: {
            sectorId: '',
            sectorName: '',
            description: '',
        }
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        subSector: [emptyStatement]
    });

    const add = () => {
        setFieldValue('subSector', [...values.subSector, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const updated = values.subSector.filter((_, i) => i !== index);
        setFieldValue('subSector', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            sector_id: id,
            sub_sector: values.subSector.map((item) => ({
                stage_id: item?.sectorId,
                sector_name: item?.sectorName,
                description: item?.description
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            if (addModal) {
                const postData = transformFormValuesToPostData(values);
                try {
                    const res = await postSubSectorAdd(postData);
                    toast.success(res.data.message);
                    postUpdateSubSectors();
                    setLoadings(false);
                    setAddModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (editModal) {
                let postData = {
                    sector_name: values.sectoreName,
                    description: values.edescription,
                }

                try {
                    const res = await patchSectorUpdate(values.esectoreId, postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    postUpdateSubSectors();
                    setEditModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;


    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        try {
            const res = await getSectorDetails(rowData?.sector_id);
            setFieldValue('esectoreId', res.data.data.sector_id);
            setFieldValue('sectoreName', res.data.data.sector_name);
            setFieldValue('edescription', res.data.data.description);

            setLoadings(false);
            setEditModal(true);

        } catch (error) {
            setLoadings(false);
            setEditModal(false);
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('esectoreId', rowData?.sector_id);
        setFieldValue('sectoreName', rowData?.sector_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteSector(values.esectoreId);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateSubSectors();
            setFieldValue('esectoreId', '');
            setFieldValue('sectoreName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles={data?.sector?.sector_name + 'Sub Sectors'} active={data?.sector?.sector_name + 'Sub Sectors'} items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <div className='Navtablist'>
                                <ul>
                                    {masterData?.map((item) => (
                                        <li><NavLink to={"/masters/sectors/" + item.sector_id}>{item.sector_name}</NavLink></li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>{data?.sector?.sector_name} Sub Sectors</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => setAddModal(true)}
                                                    >
                                                        Add New
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.subSector.map((sector, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>Sub Sector {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                    {values.subSector.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Sub Sector Name</label>
                                            <input type="text"
                                                name="sectorName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={sector.sectorName}
                                                onChange={(e) => setFieldValue(`subSector[${index}].sectorName`, e.target.value)}
                                            />
                                            {errors?.subSector?.[index]?.sectorName &&
                                                touched?.subSector?.[index]?.sectorName && (
                                                    <p className="errormsg">{errors.subSector[index].sectorName}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Description</label>
                                            <input type="text"
                                                name="description"
                                                className="form-control"
                                                autoComplete='off'
                                                value={sector.description}
                                                onChange={(e) => setFieldValue(`subSector[${index}].description`, e.target.value)}
                                            />
                                            {errors?.subSector?.[index]?.description &&
                                                touched?.subSector?.[index]?.description && (
                                                    <p className="errormsg">{errors.subSector[index].description}</p>
                                                )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Sub Sectors"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Sub Sector Name</label>
                                <input
                                    type='text'
                                    id="sectoreName"
                                    name="sectoreName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.sectoreName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.sectoreName && touched.sectoreName && (
                                    <p className="errormsg">{errors.sectoreName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Description</label>
                                <textarea
                                    type='text'
                                    id="edescription"
                                    name="edescription"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.edescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.edescription && touched.edescription && (
                                    <p className="errormsg">{errors.edescription}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>



            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.sectoreName}</span> Sub Sectors?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default SubSectors